The additional `WebhookAttempt`-specific criteria to filter by.
